import { createContext } from 'react';

export interface UniSelectorContextType {
  selectedUniversityId: string | null;
  setSelectedUniversityId: (value: string | null) => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const UniSelectorContext = createContext<UniSelectorContextType>({
  selectedUniversityId: null,
  setSelectedUniversityId: () => {},
});

export const UniSelectorProvider = UniSelectorContext.Provider;
